import { useEffect, useState } from 'react';
import cx from 'classnames';
import { useMediaQuery } from 'react-responsive';
import { useSelector } from 'react-redux';
import { matchPath } from 'react-router';
import { Route, useHistory, useLocation } from 'react-router-dom';
import { useDelayUnmount } from 'Hooks';
import { isObjEmpty, Names } from 'Utils';
import {
	MapSearchBox,
	SidebarList,
	SidebarStory,
	SidebarListLoading,
	Player
} from 'Elements';
import styles from 'partials/page-sidebar.module.scss';

export const PageSidebar = ({ isOpen, className }) => {
	const markers = useSelector((state) => state.marker);
	const track = useSelector((state) => state.player);
	const history = useHistory();
	const location = useLocation();
	const match = matchPath(location.pathname, {
		path: `${Names.story.path}/:story_id/:story_slug`,
		exact: true,
		strict: false
	});
	const params = match?.params;
	const [openPage, setOpenPage] = useState(false);
	const shouldRenderStory = useDelayUnmount(openPage, 350);
	const shouldRenderList = useDelayUnmount(!openPage, 350);
	const isDesktop = useMediaQuery({ minWidth: 992 });
	const selectedId = markers.selectedMarker?.id || params?.story_id;

	const handleClickStory = () => {
		setOpenPage(true);
	};

	const handleBack = () => {
		setOpenPage(false);
		history.push(Names.story.path);
	};

	useEffect(() => {
		setOpenPage(!isObjEmpty(markers.selectedMarker) || selectedId);
	}, [markers.selectedMarker, selectedId]);

	const sidebarClass = cx(styles.sidebox, className, {
		[styles.open]: isOpen,
		[styles.closing]: !isOpen && !isDesktop
	});

	return (
		<div className={sidebarClass}>
			{isDesktop && <MapSearchBox />}
			{markers.loading && <SidebarListLoading />}
			{!markers.loading && shouldRenderList && (
				<SidebarList
					isOpen={!openPage}
					onClickItem={handleClickStory}
				/>
			)}
			{shouldRenderStory && (
				<SidebarStory
					isOpen={openPage}
					onBack={handleBack}
					selectedId={selectedId}
				/>
			)}
			<Route
				path={`${Names.story.path}/:story_id/:story_slug`}
				render={(props) =>
					shouldRenderStory && (
						<SidebarStory
							{...props}
							selectedId={selectedId}
							isOpen={openPage}
							onBack={handleBack}
						/>
					)
				}
			/>
			{track?.activeTrackId && <Player />}
		</div>
	);
};
